const compareAlpha = (a, b) =>
  String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });

const sortValueFor = (row, column, scopeOptions) => {
  switch (column) {
    case 'value':
      if (row?.type === 'array' || Array.isArray(row?.values)) {
        return (row.values || []).join('\u0001');
      }
      return row.value || '';
    case 'type':
      if (row?.type === 'array' || Array.isArray(row?.values)) return 'array';
      if (row?.type === 'number') return 'number';
      return 'text';
    case 'description':
      return row.description || '';
    case 'scope': {
      if (row.scope === 'inherited') return row.sourceName || 'Inherited';
      const opt = scopeOptions.find((o) => o.value === row.scope);
      return opt?.label || row.scope || '';
    }
    case 'name':
    default:
      return row.name || '';
  }
};

export const sortRows = (rows, column, direction, scopeOptions) => {
  const sign = direction === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const cmp = compareAlpha(sortValueFor(a, column, scopeOptions), sortValueFor(b, column, scopeOptions));
    if (cmp !== 0) return cmp * sign;
    return compareAlpha(a.id, b.id) * sign;
  });
};

export const rowKey = (scope, id, sourceId) =>
  scope === 'inherited' ? `inherited-${sourceId}-${id}` : `${scope}-${id}`;
